module.exports = __webpack_public_path__ + "img/business-solutions-secondary-hero@2x.58b2e331.webp";